import { call } from 'redux-saga/effects';
import { sagaRoutineRequest } from '../../../helpers/saga';
import * as Api from '../../../services/fbm-api';
import { fetchSignature as fetchSignatureRoutine } from './routines';

export const fetchSignature = ({ payload: { id } }) =>
  sagaRoutineRequest(fetchSignatureRoutine, {
    request: () => call(Api.fetchSignature, id)
  });
